import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'repeat',
  templateUrl: './repeat.component.html',
  styleUrl: './repeat.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RepeatComponent extends FieldArrayType implements OnInit {
  ngOnInit() {
    if (!this.field.fieldGroup?.length) {
      this.add();
    }
  }
}
